import { render } from "./App.vue?vue&type=template&id=70e0d0dc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=70e0d0dc&lang=css"

import exportComponent from "C:\\JavaWorkSpace\\cbzbs-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__